/**
 * @license The MIT License (MIT)
 * @copyright Stanislav Kalashnik <darkpark.main@gmail.com>
 */

'use strict';

// public
module.exports = require('spa-component-page');

// correct component name
module.exports.prototype.name = 'stb-component-page';
